import { useState } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { tourConfigsState, translationDataState, useRecoilValue } from '../../../../store';

import TourImageDescriptionMinized from '@/components/ticketingNew/components/TourImageDescriptionMinized';
import StepsBlock from '@/components/ticketingNew/components/StepsBlock';
import UserCard from '@/components/ticketingNew/components/UserCard';
import BackButton from '@/components/ticketingNew/components/BackButton';
import OrderDetailsBlock from '@/components/ticketingNew/components/OrderDetailsBlock';

import { OrderMainWrap } from './styled';

export type TTicketData = { id: number; fullName: string; email: string; isGift: boolean };
const getInitialTicketData = () => ({ id: Date.now(), fullName: '', email: '', isGift: false });

export enum OrderStageEnum {
  order = 2,
  payment,
  tourOrderOnlySuccess,
}

export enum TicketPaymentType {
  NoPayment = 'noPayment',
  Paypal = 'paypal',
  Stripe = 'stripe',
  Pelecard = 'pelecard',
}

const Order = (props: any) => {
  const { match, matterId, tourId, gameId } = props;
  const { add_a_ticket = 'Add a ticket', sign_up_process = 'Sign up process', payment = 'Payment' } = useRecoilValue(translationDataState);
  const history = useHistory();
  const [orderStage, setOrderStage] = useState<OrderStageEnum>(OrderStageEnum.order);
  const [participants, setParticipants] = useState<TTicketData[]>([getInitialTicketData()]);
  const [orderLink, setOrderLink] = useState('');
  const { rtl } = useRecoilValue(tourConfigsState);

  const handleAddTicket = () => setParticipants([...participants, getInitialTicketData()]);
  const handleSetTicketData = (props: { id: number; target: string; value: any }) => {
    setParticipants(
      participants.map((ticket: TTicketData) => {
        if (ticket.id === props.id) return { ...ticket, [props.target]: props.value };
        return ticket;
      }),
    );
  };
  const handleRemoveTicket = (id: number) => {
    setParticipants(participants.filter((ticket: TTicketData) => ticket.id !== id));
  };
  const handlePaymentSuccess = () => {
    if (match?.params?.ticketId) history.push(`${match?.params?.ticketId}/success`);
  };

  return (
    <OrderMainWrap rtl={rtl}>
      <TourImageDescriptionMinized />
      <BackButton
        backFunction={
          orderStage === OrderStageEnum.order
            ? null
            : () => {
                setOrderStage(OrderStageEnum.order);
              }
        }
      />
      <StepsBlock count={3} active={orderStage} done={orderStage === OrderStageEnum.order ? [1] : [1, 2]} />
      <div className="bl-signUp-text">{orderStage === OrderStageEnum.order ? sign_up_process : payment}</div>
      {orderStage === OrderStageEnum.order ? (
        <div className="bl-ticket-main-wrap">
          <div className="bl-tickets-wrap">
            {participants.map((ticket: any, ticketNum: number) => (
              <UserCard ticket={ticket} ticketNum={ticketNum} key={ticket.id} setTicketData={handleSetTicketData} removeTicket={handleRemoveTicket} />
            ))}
            <div className="bl-add-ticket-wrap" onClick={handleAddTicket}>
              <div className="bl-add-plus">
                <i className="fas fa-plus" />
              </div>
              {participants.length < 50 && <div className="bl-add-text">{add_a_ticket}</div>}
            </div>
          </div>
          <OrderDetailsBlock
            matterId={matterId}
            match={match}
            handlePaymentSuccess={handlePaymentSuccess}
            participants={participants}
            setOrderStage={setOrderStage}
            tourId={tourId}
            gameId={gameId}
            setOrderLink={setOrderLink}
          />
        </div>
      ) : (
        <div className="bl-payment-wrap">
          <iframe src={orderLink} />
        </div>
      )}
    </OrderMainWrap>
  );
};

export default withRouter(Order);
